var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.66667H3.33341C2.41425 6.66667 1.66675 7.41417 1.66675 8.33333V16.6667C1.66675 17.5858 2.41425 18.3333 3.33341 18.3333H11.6667C12.5859 18.3333 13.3334 17.5858 13.3334 16.6667V8.33333C13.3334 7.41417 12.5859 6.66667 11.6667 6.66667Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 1.66667H8.33341C7.89139 1.66667 7.46746 1.84226 7.1549 2.15482C6.84234 2.46738 6.66675 2.89131 6.66675 3.33333V5H13.3334C13.7754 5 14.1994 5.17559 14.5119 5.48816C14.8245 5.80072 15.0001 6.22464 15.0001 6.66667V13.3333H16.6667C17.1088 13.3333 17.5327 13.1577 17.8453 12.8452C18.1578 12.5326 18.3334 12.1087 18.3334 11.6667V3.33333C18.3334 2.89131 18.1578 2.46738 17.8453 2.15482C17.5327 1.84226 17.1088 1.66667 16.6667 1.66667Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.2e8cbd2294f0279394610b1b941ebef0.svg";
export { ForwardRef as ReactComponent };